import api from "@/lib/api";
import { numLang } from "@/lib/num";

export const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export async function downloadFile(url, filename) {
  const res = await api.get(`${url}${url.includes("?") ? "&" : "?"}lang=${numLang()}`, { responseType: "blob" });
  const u = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = u; a.download = filename; a.click();
  URL.revokeObjectURL(u);
}
